<div class="spinner" [ngClass]="spinnerClasses"></div>
